import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ExcluirUsuarioRequest } from './types';

// ACTIONS
import { excluirUsuarioSuccess, excluirUsuarioFailure } from './actions';

function* excluirFuncionalidade(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: ExcluirUsuarioRequest } =
		request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_API,
		`usuarios/${payload.id}`,
	);

	if (response.status === 200) {
		yield put(excluirUsuarioSuccess(response));
	} else {
		yield put(excluirUsuarioFailure());
	}
}

export default all([takeLatest(Types.EXCLUIR_USUARIO, excluirFuncionalidade)]);
